import { isClientSide } from '@moda/portal-stanchions';
import { CONFIG } from '../config';

export const USER_API_URL = isClientSide()
  ? `${CONFIG.DISCOVERY_API_URL}/user-api`
  : CONFIG.USER_API_URL;
